export default __webpack_public_path__ + "static/panoramic2-e1968d254563408bfaa796a798d68476.jpg";